import React, { useCallback, useState } from "react";
import styles from "./BetaSettings.module.scss";
import {
  isAdyenForcedEnabled,
  setAdyenForcedEnabled,
  getAdyenDeviceIdOverride,
  setAdyenDeviceIdOverride,
} from "Infrastructure/repositories/localStorage/adyenFlag";

export const BetaSettings = () => {
  const [adyenEnabled, setAdyenEnabledState] = useState(isAdyenForcedEnabled);
  const [deviceIdInput, setDeviceIdInput] = useState(() => getAdyenDeviceIdOverride() ?? "");
  const [deviceIdSaved, setDeviceIdSaved] = useState(() => getAdyenDeviceIdOverride() ?? "");

  const toggleAdyen = useCallback(() => {
    const next = !adyenEnabled;
    setAdyenForcedEnabled(next);
    setAdyenEnabledState(next);
  }, [adyenEnabled]);

  const saveDeviceId = useCallback(() => {
    setAdyenDeviceIdOverride(deviceIdInput);
    setDeviceIdSaved(getAdyenDeviceIdOverride() ?? "");
  }, [deviceIdInput]);

  return (
    <div id={styles.BetaSettings}>
      <h2 className={styles.title}>Funcionalidades Beta</h2>
      <p className={styles.subtitle}>
        Recursos experimentais e status de rollout.
      </p>

      <div className={styles.featureCard}>
        <div className={styles.featureInfo}>
          <div className={styles.featureName}>
            Order Repository V2
          </div>
          <div className={styles.featureDescription}>
            Usa IndexedDB nativo (idb) com uma entrada por pedido e índices reais.
            Reduz o volume de dados lidos/gravados em cada operação de 1-2MB para ~50KB.
            V2 é usado em todos os dispositivos — o V1 foi descontinuado. Pedidos
            existentes em V1 são migrados automaticamente na próxima inicialização.
          </div>
          <div className={styles.featureImpact}>
            Afeta: gravação de logs de pagamento, PIX, recarga cashless e listagem do histórico.
          </div>
        </div>
      </div>

      <div className={styles.featureCard}>
        <div className={styles.featureInfo}>
          <div className={styles.featureName}>
            Adyen (Terminal Cloud API)
            <span className={styles.badge}>Beta</span>
          </div>
          <div className={styles.featureDescription}>
            Força o uso da Adyen Terminal Cloud API para pagamentos de débito/crédito,
            independente do adquirente configurado na loja. Use apenas para testes —
            requer configuração de API key/deviceId no ambiente deste totem.
          </div>
          <div className={styles.featureImpact}>
            Afeta: pagamento por pinpad (débito/crédito). Pix, cashless, wallet e voucher não mudam.
          </div>

          <div className={styles.deviceIdRow}>
            <input
              type="text"
              className={styles.deviceIdInput}
              placeholder="deviceId do terminal (ex: P400Plus-123456789)"
              value={deviceIdInput}
              onChange={(e) => setDeviceIdInput(e.target.value)}
            />
            <button type="button" className={styles.deviceIdSaveButton} onClick={saveDeviceId}>
              Salvar
            </button>
          </div>
          {deviceIdSaved && (
            <div className={styles.featureImpact}>
              deviceId salvo: <strong>{deviceIdSaved}</strong> (tem prioridade sobre config da loja e env var)
            </div>
          )}
        </div>

        <div className={styles.toggleWrapper} onClick={toggleAdyen}>
          <div className={`${styles.switch} ${adyenEnabled ? styles.on : ""}`}>
            <div className={styles.thumb} />
          </div>
          <span className={`${styles.toggleLabel} ${adyenEnabled ? styles.on : ""}`}>
            {adyenEnabled ? "Ativado" : "Desativado"}
          </span>
        </div>
      </div>

      {adyenEnabled && (
        <div className={styles.warning}>
          ℹ️ Recarregue o app para que os pagamentos de pinpad passem a usar a Adyen.
        </div>
      )}
    </div>
  );
};
